import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Silent OAuth session exchange: session_id in URL fragment -> backend -> cookie -> area
export const AuthCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }

        axios
            .get(`${API}/auth/session/${sessionId}`, { withCredentials: true })
            .then((res) =>
                navigate("/area-personale", {
                    replace: true,
                    state: { user: res.data.user },
                })
            )
            .catch(() => navigate("/", { replace: true }));
    }, [location.hash, navigate]);

    return null;
};

export default AuthCallback;
